import * as actionTypes from "./actionTypes";
import axios from "../../axios-amps";
import { logFirebaseEvent } from "../../shared/utility";
import { serverconfigs } from "../../constants";

export const fetchUserInfoStarted = () => {
  return {
    type: actionTypes.FETCH_USER_INFO_STARTED,
  };
};

export const fetchUserInfoSuccess = (userInfo) => {
  return {
    type: actionTypes.FETCH_USER_INFO_SUCCESS,
    userInfo: userInfo,
  };
};

export const fetchUserInfoFailed = () => {
  return {
    type: actionTypes.FETCH_USER_INFO_FAILED,
  };
};

export const fetchUserInfo = (patientId: number) => {
  return (dispatch) => {
    dispatch(fetchUserInfoStarted());
    axios
      .get(serverconfigs.fetchUserInfoUrl+`/${patientId}`)
      .then((response) => {
        console.log(response.data.result);
        dispatch(fetchUserInfoSuccess(response.data.result));
      })
      .catch((error) => {
        if (error.statusCode === 400) {
          logFirebaseEvent("Exception400");
        } else if (error.statusCode === 401) {
          logFirebaseEvent("Exception401");
        } else if (error.statusCode === 500) {
          logFirebaseEvent("Exception500");
        }
        dispatch(fetchUserInfoFailed());
      });
  };
};
